<template>
  <v-app id="inspire">
    <NavigationDrawer v-if="haIniciadoSesion && drawer" />
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
      <v-app-bar-nav-icon
        v-if="haIniciadoSesion && tieneInstanciaElegida"
        @click.stop="drawer = !drawer"
      >
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pl-4">
        <span v-if="!nombreSuscriptor" class="hidden-sm-and-down"
          >Restaurant Maestro</span
        >
        <span v-else class="hidden-sm-and-down">{{ nombreSuscriptor }} </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link
        to="/InicioSesion"
        tag="button"
        v-if="!haIniciadoSesion && muestraBotonInicioSesion"
        >Iniciar sesión</router-link
      >

      <v-btn text v-if="haIniciadoSesion && muestraBotonInicioSesion" @click="cerrarSesion()"> Cerrar sesion </v-btn>
    </v-app-bar>
    <v-main>
      <router-view class="mb-10" />
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import Vuex from "vuex";

export default {
  props: {
    source: String,
  },
  /*   computed: {
    haIniciadoSesion: function() {
      return sessionStorage.jwt !== undefined;
    },
    nombreSuscriptor: function() {
      return sessionStorage.nombreSuscriptor;
    },
  }, */
  methods: {
    ...Vuex.mapMutations([
      "setHaIniciadoSesion",
      "setClaveInstancia",
      "setNombreSuscriptor",
      "UPDATE_DRAWER_STATE",
    ]),
    cerrarSesion() {
      this.setHaIniciadoSesion(false);
      this.setNombreSuscriptor("");
      sessionStorage.removeItem("jwt");
      this.setClaveInstancia("");
      sessionStorage.removeItem("esPropietario");
      this.$store.state.drawer = false;
      this.$router.push("/");
    },
  },
  computed: {
    ...Vuex.mapState([
      "haIniciadoSesion",
      "claveInstancia",
      "nombreSuscriptor",
      "muestraBotonInicioSesion",
    ]),
    //Indica si hay una instancia seleccionada o no
    tieneInstanciaElegida: function () {
      return Boolean(this.claveInstancia);
    },
    nombreInstancia: function () {
      var w = sessionStorage.nombreInstancia;
      if (w) {
        return w;
      }
      return "";
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(newDraweState) {
        this.UPDATE_DRAWER_STATE(newDraweState);
        return newDraweState;
      },
    },
  },
  components: {
    NavigationDrawer,
  },
  data: () => ({
    dialog: false,
  }),
  mounted() {
    if (sessionStorage.jwt !== undefined) {
      this.setHaIniciadoSesion(true);
      this.setNombreSuscriptor(sessionStorage.getItem("nombreInstancia"));
    }
  },
};
</script>
